// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridCarouselContainerStyle } from "@west/App/Components/Product/ProductGridCarouselContainer";
import { css } from "styled-components";

productGridCarouselContainerStyle.container = {
    css: css`
        position: relative;
        display: grid;
        grid-auto-columns: 1fr;
        grid-template-columns: 1fr;
        grid-template-rows: 317px 70px 0.5fr 1fr;
        gap: 12px 0;
        grid-template-areas:
            "Image"
            "Variants"
            "Information"
            "SecondContainer";
        height: 100%;
    `,
};

productGridCarouselContainerStyle.image = {
    css: css`
        position: relative;
        grid-area: Image;
    `,
};

productGridCarouselContainerStyle.variant = {
    css: css`
        grid-area: Variants;
        display: flex;
        align-items: flex-end;
    `,
};

productGridCarouselContainerStyle.info = {
    css: css`
        grid-area: Information;
        display: flex;
        flex-direction: column;
    `,
};

productGridCarouselContainerStyle.secondContainer = {
    css: css`
        grid-area: SecondContainer;
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

productGridCarouselContainerStyle.price = {
    css: css`
        grid-area: Price;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex-wrap: wrap;
        gap: 8px 5px;
    `,
};

productGridCarouselContainerStyle.availability = {
    css: css`
        grid-area: Availability;
        margin-top: auto;
    `,
};

productGridCarouselContainerStyle.addToCartActions = {
    css: css`
        grid-area: AddToCart;
        display: flex;
    `,
};

productGridCarouselContainerStyle.addToList = {
    css: css`
        grid-area: Actions;
    `,
};
